import type {
  ValueFormatterFunc,
  ValueFormatterParams,
} from "ag-grid-community";

import { formatDecimal } from "lib";

// formatKg: parquet stores raw grams; convert to kg as a plain number (no unit suffix).
export const formatKg = (params: ValueFormatterParams): string => {
  if (params.value == null) return "";
  return (params.value / 1000).toFixed(1);
};

// boolYN: lib/agGrid only has checkbox cell renderers; we need a text formatter
// for use in set-filter value lists as well as cell display.
export const boolYN = (params: ValueFormatterParams): string => {
  if (params.value == null) return "";
  return params.value ? "Yes" : "No";
};

// centsToAUD: parquet stores cents; display as a plain decimal number (no $ sign).
const centsToAUD = (params: ValueFormatterParams): string =>
  params.value != null ? formatDecimal(params.value / 100, 2) : "";

// Server-side format hints (ColumnMeta.format) map to a value formatter here.
// Add new entries when the parquet export introduces a new unit/format convention.
export const FORMAT_RENDERERS: Record<string, ValueFormatterFunc> = {
  cents_to_dollars: centsToAUD,
  grams_to_kg: formatKg,
};
